import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '1.5rem',
    flexWrap: 'wrap',

    [theme.breakpoints.down('sm')]: {
      marginTop: '0',
      fontSize: theme.size.sm
    }
  },

  inputSpacing: {
    marginBottom: '1rem',
    flexBasis: '50%',
    width: '50%',
    justifyContent: 'flex-start',

    [theme.breakpoints.up(1024)]: {
      marginBottom: '0'
    }
  },

  label: {
    display: 'inline-flex',
    alignItems: 'center',
    width: 145,
    textTransform: 'uppercase',
    color: theme.palette.textLight,

    [theme.breakpoints.down(965)]: {
      marginBottom: '0.75rem'
    },

    [theme.breakpoints.up(1024)]: {
      fontSize: theme.size.sm
    }
  },

  icon: {
    flexShrink: 0,
    marginRight: '5px'
  },

  input: {
    flexGrow: 1,
    outline: 'none',
    border: 'none',
    padding: 0,
    background: 'transparent',
    maxWidth: '300px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    color: theme.palette.textLight,
    fontSize: theme.size.sm
  },

  dropdownInput: {
    width: '50%',
    color: theme.palette.textLight,
    fontSize: theme.size.sm,

    [theme.breakpoints.down('md')]: {
      marginBottom: '0'
    }
  }
}))

export default useStyles
